export enum DocumentClassification {
  COMPANY = "COMPANY",
  CUSTOMER = "CUSTOMER",
  WORK_ORDER = "WORK_ORDER",
}
